<template>
    <div class="toggles-item">
        <div :class="['toggle', {'is-active': isActive}]" @click="toggle">
            <slot name="toggle"></slot>
        </div>

        <height-transition :initial-show="active">
            <div :class="['data', {'is-active': isActive}]" v-show="isActive">
                <slot></slot>
            </div>
        </height-transition>
    </div>
</template>

<script>
    import HeightTransition from './HeightTransition';

    export default {
        name: "TogglesItem",

        components: {
            HeightTransition
        },

        props: {
            id: { default: null },
            active: {
                type: Boolean,
                default: false
            },
        },

        mounted() {
            this.toggleCheckbox = this.$el.querySelector('.toggle [type="checkbox"]');

            if (this.toggleCheckbox) {
                this.toggleCheckbox.addEventListener('click', e => {
                    e.preventDefault();
                    this.toggle();
                });
            }

            if (this.rememberActive && this.id && this.isRememberedActive()) {
                this.toggle();
            }
        },

        data() {
            return {
                isActive: this.active,
                rememberActive: this.$parent.rememberActive,
                toggleCheckbox: null
            }
        },

        watch: {
            isActive(val) {
                this.rememberMe();
                if (this.toggleCheckbox) this.toggleCheckbox.checked = val;
            }
        },

        methods: {
            toggle() {
                this.$parent.$emit('toggle', this);
            },

            rememberMe() {
                var activeToggles = JSON.parse(window.localStorage.getItem("pxn.toggles.activeToggleId"));

                if (this.isActive) {
                    activeToggles.push(this.id);
                } else {
                    activeToggles = activeToggles.filter(item => item !== this.id)
                }

                window.localStorage.setItem("pxn.toggles.activeToggleId", JSON.stringify(activeToggles));
            },

            isRememberedActive() {
                var activeToggles = window.localStorage.getItem("pxn.toggles.activeToggleId");
                return activeToggles.indexOf(this.id) > -1;
            }
        }
    };
</script>
